/**
*
* Notification
*
*/

import React from 'react';
import PropTypes from 'prop-types';

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = (props.onClickAction) ? () => props.dispatcher(props.onClickAction) : null;
    this.onDismiss = (props.onDismissAction) ? () => { props.dispatcher(props.onDismissAction); props.dismiss(props.id); } : () => props.dismiss(props.id);
  }

  toggleClass(type) {
    return `alert-${type}`;
  }

  render() {
    const { notificationType, message } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
      <div
        className={`alert ${this.toggleClass(notificationType)} mb-0 py-4 d-flex justify-content-center`}
        role="alert"
        onClick={this.onClick}
      >
        <strong className="m-auto">{message}</strong>
        <button
          className="close"
          onClick={this.onDismiss}
          type="button"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  }
}

Notification.propTypes = {
  id: PropTypes.any.isRequired,
  notificationType: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  dispatcher: PropTypes.func.isRequired,
  dismiss: PropTypes.func.isRequired,
  onClickAction: PropTypes.any,
  onDismissAction: PropTypes.any,
};

Notification.defaultProps = {
  onClickAction: null,
  onDismissAction: null,
};

export default Notification;
